module.exports = __webpack_public_path__ + "static/media/theme-silhouette.a576cd79.svg";